import { BuilderTypes } from '@frontend/forms-builder-engine';
import { contextFactory } from '@frontend/design-system';

export interface CategoriesPreviewContextValue {
  optionSetLabel: string;
  optionSet?: BuilderTypes.PrimaryMedicalHistoryFieldTypes.OptionSetType;
}

export const [CategoriesPreviewContext, useCategoriesPreviewContext] = contextFactory<CategoriesPreviewContextValue>();
